module.exports = __webpack_public_path__ + "img/top.e682dc15.svg";